import { useState } from 'react'
import { DatePicker } from '../DatePicker/DateRangePicker'
import { es } from 'date-fns/locale'
interface Props {
    onChange: (e: string) => void
    placeholder?: string
    allDays?: boolean
}

export const AppInputDate = ({
    onChange,
    placeholder = 'Seleccionar fecha',
    allDays = true,
}: Props) => {
    const [date, setDate] = useState<Date | undefined>()
    const formatDateToYMD = (date: Date | undefined) => {
        if (!date) return ''

        const year = date.getFullYear()
        const month = String(date.getMonth() + 1).padStart(2, '0')
        const day = String(date.getDate()).padStart(2, '0')

        return `${year}-${month}-${day}`
    }

    const handleDateChange = (e: Date | undefined) => {
        const formatDate = formatDateToYMD(e)
        setDate(e)
        onChange(formatDate)
    }

    return (
        <DatePicker
            enableYearNavigation
            value={date}
            onChange={handleDateChange}
            className="w-full"
            placeholder={placeholder}
            disabledDays={!allDays && ((date) => date > new Date())}
            locale={es}
            translations={{
                cancel: 'Cancelar',
                apply: 'Aplicar',
            }}
        />
    )
}
